import React from 'react';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Controller } from "react-hook-form";
import OutlinedInput from '@mui/material/OutlinedInput';
import { FormHelperText } from '@mui/material';
import { CustomDropdownIcon } from '../CustomDropDownIcon';




export const SelectTypeInput = ({
    name,
    label,
    control,
    defaultValue,
    placeholder,
    children,
    errors,
    rules,
    height,
    width,
    onChange,
    options = [],
    ...props
}) => {
    return (

        <div className="flex flex-col gap-2 " key={`SelectTypeInput-${name}`}>
            <FormControl sx={{ m: 1 }}>
                <label >{label}</label>
                <Controller
                    name={name}
                    control={control}
                    defaultValue={defaultValue}
                    rules={rules}
                    render={({ field }) => (
                        <Select
                           native={true}
                            {...field}
                            displayEmpty
                            label={label}
                            id={`select-${name}`}
                            onChange={(e) => { field.onChange(e.target.value); onChange && onChange(e.target.value) }}
                            input={<OutlinedInput sx={{ padding: 0, margin: 0 }} />}
                            // sx={checkboxStyle}
                            IconComponent={CustomDropdownIcon}
                            style={{ width, height, borderRadius: '0.5rem' }}
                            className="py-5.5"
                            MenuProps={{
                                PaperProps: {
                                    style: {
                                        width: 'auto', // This ensures the menu width takes the Select width
                                    },
                                },
                                getContentAnchorEl: null,
                                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                            }}
                            // renderValue={(selected) => {
                            //     return (
                            //         <div className="flex flex-row align-center justify-between text-base">
                            //             <div class={` ${ (selected || defaultValue) ? "text-black" : "text-[#70829B] "} overflow-hidden text-ellipsis  truncate font-sans text-base font-normal leading-6 `}>
                            //                 {!selected && !defaultValue ? (placeholder) : (selected || defaultValue)} 
                            //             </div>
                            //         </div>
                            //     )
                            // }}
                            placeholder={placeholder}
                            disabled={props.columnCheck}
                        >
                            {placeholder && <option aria-label="None" value="" >{placeholder}</option> }
                            {options.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.title}
                                </option>
                            ))}
                        </Select>
                    )}
                />
                
                {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
            </FormControl>
        </div>
    );
};
